"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["children", "classes", "onClose"],
  _excluded2 = ["classes"],
  _excluded3 = ["classes"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DialogTitle = (0, _styles.withStyles)(function (theme) {
  return {
    title: {
      borderBottom: "1px solid ".concat(theme.palette.lightGrey.light),
      display: 'flex',
      alignItems: 'center'
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      fontWeight: 'bold'
    },
    closeButton: {
      padding: 0
    }
  };
})(function (_ref) {
  var children = _ref.children,
    classes = _ref.classes,
    onClose = _ref.onClose,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], _extends({
    disableTypography: true,
    className: classes.title
  }, other), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h6",
    classes: {
      root: classes.content
    }
  }, children), onClose ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: onClose,
    color: "primary"
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)) : null);
});
var DialogActions = (0, _styles.withStyles)(function (theme) {
  return {
    root: _defineProperty({
      flexWrap: 'wrap',
      borderTop: "1px solid ".concat(theme.palette.lightGrey.light),
      padding: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      flexDirection: 'column',
      '& button': {
        width: '100%'
      },
      '& :not(:first-child)': {
        margin: 0
      }
    })
  };
})(function (_ref2) {
  var classes = _ref2.classes,
    other = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], _extends({
    className: classes.root
  }, other));
});
var DialogContent = (0, _styles.withStyles)(function () {
  return {
    content: {
      minHeight: 120,
      padding: 0
    }
  };
})(function (_ref3) {
  var classes = _ref3.classes,
    other = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], _extends({
    className: classes.content
  }, other));
});
var Dialog = function Dialog(_ref4) {
  var title = _ref4.title,
    children = _ref4.children,
    action = _ref4.action,
    secondaryAction = _ref4.secondaryAction,
    handleClose = _ref4.handleClose;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(DialogTitle, {
    onClose: handleClose
  }, title), /*#__PURE__*/_react["default"].createElement(DialogContent, null, children), !!action && /*#__PURE__*/_react["default"].createElement(DialogActions, null, secondaryAction && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "tertiary",
    onClick: secondaryAction.onClick,
    disabled: secondaryAction.disabled
  }, secondaryAction.name), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: action.onClick,
    disabled: action.disabled
  }, action.name)));
};
Dialog.propTypes = {
  title: _propTypes["default"].node.isRequired,
  children: _propTypes["default"].node.isRequired,
  action: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    disabled: _propTypes["default"].bool
  }),
  secondaryAction: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    onClick: _propTypes["default"].func,
    disabled: _propTypes["default"].bool
  }),
  handleClose: _propTypes["default"].func
};
Dialog.defaultProps = {
  action: null,
  secondaryAction: null,
  handleClose: undefined
};
var _default = exports["default"] = Dialog;